module.exports = __webpack_public_path__ + "img/barClockChart.5ad793a7.svg";